/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-reference-dossier': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M17.7 12.84l-2.48 1.8.89 2.87a.37.37 0 01-.14.42.36.36 0 01-.22.07.34.34 0 01-.22-.07l-2.41-1.76-2.4 1.76a.39.39 0 01-.44 0 .37.37 0 01-.14-.42l.86-2.87-2.47-1.8a.37.37 0 01-.14-.42.39.39 0 01.36-.26h3.05l.95-2.9a.39.39 0 01.71 0l.94 2.9h3.06a.38.38 0 01.35.26.36.36 0 01-.11.42zM13.5.37v7.5a.38.38 0 01-.38.38 1.13 1.13 0 00-1.07.75l-.69 2.12a.36.36 0 01-.35.26H8.77a1.13 1.13 0 00-.66 2l1.82 1.32a.38.38 0 01.14.42l-.32 1a.37.37 0 01-.36.27h-9a.38.38 0 01-.39-.27V4.87a.38.38 0 01.11-.26l4.5-4.5A.38.38 0 014.87 0h8.25a.38.38 0 01.38.37zm-9 3.75V1.28L1.28 4.5h2.84a.38.38 0 00.38-.38z"/>'
  }
})
